
import Vue from 'vue';
import Token from '../Token';

import { Padder } from '../Spacings';
import { Row, Column } from '../Grid';

import addMore from '../../Icons/AddMore.vue';
import uploadIcon from '../../Icons/UploadIcon.vue';
import reloadIcon from '../../Icons/ReloadIcon.vue';
import deleteIcon from '../../Icons/DeleteIcon.vue';

/**
 * Multi Uploader Component.
 *
 * Upload multiple image and show like gallery.
 */
export default Vue.extend<any, any, any, any>({
  name: 'MultipleUploader',
  components: {
    Padder,
    Row,
    Column,
    addMore,
    uploadIcon,
    reloadIcon,
    deleteIcon
  },
  props: {
    /**
     * Title of the Uploader.<br />
     * Label in the top of the Upload List.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Document type, for file name and Vue refs.
     */
    documentType: {
      type: String,
      default: ''
    },
    /**
     * Value of image uploads.<br />
     * Model of the list:
     *
     * - name: File name modified.
     * - previewImage: URL of the file
     * - content: Base64 of the file
     */
    documentArray: {
      type: Array,
      default: () => []
    },
    /**
     * *documentOwner deprecated*
     */
    documentOwner: {
      type: String,
      default: ''
    },
    /**
     * Hex color background of the Image Uploader.
     */
    defaultBackground: {
      type: String,
      default: ''
    },
    /**
     * Preview image of uploader.<br />
     * Possible value: background-size css property.
     */
    backgroundSize: {
      type: String,
      default: 'contain'
    }
  },
  data() {
    return {
      Token: Token,
      documentArr: [],
      upload: ''
    };
  },
  created() {
    this.documentArr = this.documentArray;
  },
  methods: {
    addMoreItems() {
      this.documentArr.push({ previewImage: '', name: 'initial-file', content: '' });
      this.$forceUpdate();
    },
    computedBackground(defaultBackground: string, value: string) {
      if (!value) {
        return `background-image: url(${defaultBackground}); background-size: (${this.backgroundSize})`;
      } else {
        return `background-image: url(${value}); background-size: ${this.backgroundSize}`;
      }
    },
    chooseFilesDocument(key: string, index: string) {
      this.upload = key;
      // @ts-ignore
      this.$refs[`fileUploadDocument_${key}_${index}`][0].click();
      this.$forceUpdate();
    },
    previewImageDocument(event: Event, key: string, index: string) {
      this.$forceUpdate();
      // @ts-ignore
      const input = event.target;
      // @ts-ignore
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          let result;
          // @ts-ignore
          result = e.target.result.split('base64,')[1];

          // @ts-ignore
          this.documentArr[index - 1] = {
            name: this.documentType + '-' + name + '.' + fileType,
            previewImage: img.src,
            content: result
          };
          // @ts-ignore
          /**
           * Handle when the input value change.
           * @event input
           * @type {function}
           */
          this.$emit('input', this.documentArr);
          this.$forceUpdate();
        };
        // @ts-ignore
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        img.onload = () => {
          const options = {
            maxWidth: 800,
            maxHeight: 800,
            quality: 0.7,
            // @ts-ignore
            success(result) {
              reader.readAsDataURL(result);
            },
            // @ts-ignore
            error(e) {
              console.log(e.message);
            }
          };
          // @ts-ignore
          reader.readAsDataURL(input.files[0]);
        };
        // @ts-ignore
        img.src = _URL.createObjectURL(input.files[0]);
        // @ts-ignore
        const fileType = input.files[0].type.replace('image/', '');
        const name = this.documentOwner.split(' ').join('_');
      }
    },
    deleteDoc(index: string) {
      // @ts-ignore
      this.documentArr.splice(index - 1, 1);
    }
  }
});
